module.exports = __webpack_public_path__ + "img/bg (4).ae128626.jpg";